<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Claims Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> / <b>Reports</b> /
      <b>Claims</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <!-- ICON BG -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-icon-bg card-icon-bg-primary o-hidden mb-4">
          <div class="card-body text-center">
            <i class="nav-icon fas fa-handshake" style="font-size:50px"></i>
            <div class="content">
              <p class="text-muted mt-2 mb-0">Claim Quantity</p>
              <p class="text-primary text-24 line-height-1 mb-2 ">
                <span>{{ this.claim_quantity }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input class="form-control" type="date" v-model="date_from" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input class="form-control" type="date" v-model="date_to" />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label><b>Takaful Schema</b></label>
                <select class="form-control" v-model="productFilter">
                  <option value="" selected>All</option>
                  <option
                    v-for="(product, prod_index) in products"
                    :key="prod_index"
                    :value="product.id"
                    >{{ product.name }}</option
                  >
                </select>
              </div>
              <div class="col-6">
                <label><b>Status</b></label>
                <select class="form-control" v-model="statusFilter">
                  <option value="" selected>All</option>
                  <option
                    v-for="(status, stat_index) in statuses"
                    :key="stat_index"
                    :value="status.id"
                    >{{ status.name }}</option
                  >
                </select>
              </div>
            </div>
            <br />
            <div class="text-right">
              <button
                @click="submit_filter()"
                class="btn btn-rounded btn-primary"
                style="width: 150px;"
              >
                Submit
              </button>
            </div>
            <br />
            <div class="table-responsive">
              <table
                id="claim_table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: left;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Status</th>
                    <th>Customer Name</th>
                    <th>Scheme</th>
                    <th>Claim Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, claim_index) in claims" :key="claim_index">
                    <td>{{ claim_index + 1 }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-rounded m-1"
                        style="width: 150px; background-color: #AC8400; border-color: #AC8400;"
                      >
                        {{ claim.status.name }}
                      </button>
                    </td>
                    <td>{{ claim.customer.user.name }}</td>
                    <td>{{ claim.certificate.detail.product.name }}</td>
                    <td>{{ claim.created_at | moment("Do MMMM YYYY") }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <br />
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
export default {
  name: "report-claims",
  components: {},

  data() {
    return {
      claims: [
        {
          customer: {
            user: {
              name: ""
            }
          },
          certificate: {
            detail: {
              product: {
                name: ""
              }
            }
          },
          status: {
            name: ""
          },
          created_at: ""
        }
      ],
      statusFilter: "",
      productFilter: "",
      date_to: "",
      date_from: "",
      claim_quantity: "",
      statuses: [],
      products: []
    };
  },

  methods: {
    loadDetails() {
      let token = localStorage.getItem("token");
      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/reports/claims",
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.claims = res.data.records;
            this.claim_quantity = res.data.total_claims;
          });
      }
    },

    loadStatus() {
      let token = localStorage.getItem("token");

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/statuses/claim", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.statuses = res.data;
          });
      }
    },

    loadProduct() {
      let token = localStorage.getItem("token");

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/products/staff", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.products = res.data;
          });
      }
    },

    submit_filter() {
      let token = localStorage.getItem("token");
      //check if has token
      if (token !== null) {
        $("#claim_table")
          .DataTable()
          .destroy();
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/reports/claims",
            {
              status: this.statusFilter,
              product: this.productFilter,
              date_from_p: this.date_from,
              date_to_p: this.date_to
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.claims = res.data.records;
            this.claim_quantity = res.data.total_claims;
            setTimeout(function() {
              $("#claim_table").DataTable({
                dom: "Bfrtip",
                lengthMenu: [
                  [5, 10, 25, 50, -1],
                  ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
                ],
                buttons: [
                  "pageLength",
                  "colvis",
                  "csv",
                  "excel",
                  "pdf",
                  "print"
                ]
              });
            }, 1000);
          });
      }
    },

    loadAllData() {
      this.loadDetails();
      this.loadStatus();
      this.loadProduct();
      setTimeout(function() {
        $("#claim_table").DataTable({
          dom: "Bfrtip",
          lengthMenu: [
            [5, 10, 25, 50, -1],
            ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
          ],
          buttons: ["pageLength", "colvis", "csv", "excel", "pdf", "print"]
        });
      }, 1000);
    }
  },

  mounted() {
    this.loadAllData();
  }
};
</script>
